// api.js — все запросы к cloud functions (Gateway не проксирует CORS-запросы POST)
const AUTH_URL = 'https://functions.yandexcloud.net/d4ee415qiap5ddmlq4jo';
const SPEECHKIT_URL = 'https://functions.yandexcloud.net/d4enk2n4s6v2n4mp3isc';
const DEEPSEEK_URL = 'https://functions.yandexcloud.net/d4emasoq9kkfni8htqdr';
const DEEPSEEK_PROMPT2_URL = 'https://functions.yandexcloud.net/d4eo2c9gradnku2kkna1';
const MEALS_URL = 'https://functions.yandexcloud.net/d4ekefdas50og07i6qh1';
const USERS_URL = 'https://functions.yandexcloud.net/d4eelt0o01g7hqlesrv7';
const ADMIN_URL = 'https://functions.yandexcloud.net/d4euki19f0tg78bvd2qo';
const ROLE_URL = 'https://functions.yandexcloud.net/d4eebrud75bhn6fbsjpr';
const MENTOR_URL = 'https://functions.yandexcloud.net/d4esg1auguv0hj1pp5i2';
const SAVE_PROMPTS_URL = 'https://functions.yandexcloud.net/d4ecevuv8a0bgq39celc';
// Чат по потокам/группам (новые облачные функции)
const CHAT_SYNC_URL = 'https://functions.yandexcloud.net/d4e2sq0ifeovmn208g8c';
const CHAT_ADMIN_URL = 'https://functions.yandexcloud.net/d4easchf18s0spmakf4v';

const post = async (url, body) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    });
    return response.json();
};

// === АВТОРИЗАЦИЯ ===
export const loginUser = (login, password) => post(AUTH_URL, { login, password });

export const registerUser = (login, password, name, inviteCode) => post(AUTH_URL, { action: 'register', login, password, name, inviteCode });

export const verifyToken = (login, token) => post(AUTH_URL, { action: 'verify', login, token });

export const changePassword = (login, token, currentPassword, newPassword) => post(AUTH_URL, { action: 'changePassword', login, token, currentPassword, newPassword });

export const checkRequestLimit = (login, token) => post(AUTH_URL, { action: 'verify', login, token });

// === ПРОФИЛЬ ===
export const loadProfile = (login, token) => post(USERS_URL, { action: 'loadProfile', login, token });

export const saveProfile = (login, token, profile) => post(USERS_URL, { action: 'saveProfile', login, token, profile });

export const clearMentor = (login, token) => post(USERS_URL, { action: 'clearMentor', login, token });

// === SPEECHKIT ===
export const recognizeSpeech = (login, token, audioBase64) => post(SPEECHKIT_URL, { login, token, audio: audioBase64 });

// === AI (DeepSeek) ===
export const analyzeMeal = (login, token, rawText, userParams, dailyNorms) =>
    post(DEEPSEEK_URL, { login, token, rawText, userParams, dailyNorms });

export const getAdvice = (login, token, mealData, userParams, userChoice, dailyNorms, dayTotals) =>
    post(DEEPSEEK_PROMPT2_URL, { login, token, mealData, userParams, userChoice, dailyNorms, dayTotals });

// === ИСТОРИЯ ПРИЁМОВ ===
export const loadHistory = (login, token) => post(MEALS_URL, { action: 'load', login, token });

export const saveMealToHistory = (login, token, meal) => post(MEALS_URL, { action: 'save', login, token, meal });

export const deleteMealFromHistory = (login, token, meal) => post(MEALS_URL, { action: 'delete', login, token, meal });

export const updateMealInHistory = (login, token, meal) => post(MEALS_URL, { action: 'update', login, token, meal });

// === РОЛИ (отдельная cloud function) ===
export const setUserRole = (password, login, role) => post(ROLE_URL, { action: 'setRole', password, login, role });

export const getUserRole = (login, token) => post(ROLE_URL, { action: 'getRole', login, token });

// === НАСТАВНИК ===
export const mentorListStudents = (login, token, streamId) => post(MENTOR_URL, { action: 'listStudents', login, token, streamId });

export const mentorListStreams = (login, token) => post(MENTOR_URL, { action: 'listStreams', login, token });

export const mentorGetStudentProfile = (login, token, studentLogin, streamId) => post(MENTOR_URL, { action: 'getStudentProfile', login, token, studentLogin, streamId });

export const mentorGetStudentStats = (login, token, studentLogin, date, streamId) => post(MENTOR_URL, { action: 'getStudentStats', login, token, studentLogin, date, streamId });

// ВАЖНО: mentorDeleteStudent удалён 2026-09-10 — отвязка людей теперь в админке (потоки).
// Оставлен пустой заглушкой, чтобы старые импорты не ломали сборку.
export const mentorDeleteStudent = null;

export const getMentorName = null; // удалено 2026-09-10: привязки по mentorId больше нет

// === АДМИНКА ===
export const adminAction = (password, action, payload = {}) => post(ADMIN_URL, { password, action, ...payload });

export const adminSavePrompts = (password, prompts) => post(SAVE_PROMPTS_URL, { password, ...prompts });

// === PUSH-УВЕДОМЛЕНИЯ ===
export const subscribePush = (login, token, subscription) => post(USERS_URL, { action: 'subscribePush', login, token, subscription });

export const unsubscribePush = (login, token, subscription) => post(USERS_URL, { action: 'unsubscribePush', login, token, subscription });

export const getPushStatus = (login, token) => post(USERS_URL, { action: 'getPushStatus', login, token });

// === ПРОМОКОДЫ ===
export const activatePromoCode = (login, token, promoCode) => post(ADMIN_URL, { action: 'activatePromo', login, token, promoCode });

export const listPromoCodes = (password) => post(ADMIN_URL, { action: 'listPromos', password });

export const createPromoCode = (password, code, tier, maxUses) => post(ADMIN_URL, { action: 'createPromo', password, code, tier, maxUses });

export const deletePromoCode = (password, code) => post(ADMIN_URL, { action: 'deletePromo', password, code });

// === ЧАТ ПО ПОТОКАМ/ГРУППАМ (для пользователя, через токен) ===
export const chatGetMyStreams = (login, token) => post(CHAT_SYNC_URL, { action: 'getMyStreams', login, token });

export const chatGetMessages = (login, token, streamId) => post(CHAT_SYNC_URL, { action: 'getMessages', login, token, streamId });

export const chatSendMessage = (login, token, streamId, text) => post(CHAT_SYNC_URL, { action: 'send', login, token, streamId, text });

export const chatDeleteMessage = (login, token, streamId, messageId) => post(CHAT_SYNC_URL, { action: 'delete', login, token, streamId, messageId });

export const chatEditMessage = (login, token, streamId, messageId, text) => post(CHAT_SYNC_URL, { action: 'edit', login, token, streamId, messageId, text });

export const chatMarkRead = (login, token, streamId) => post(CHAT_SYNC_URL, { action: 'markRead', login, token, streamId });

// === ЧАТ: управление потоками (админка, через пароль) ===
export const chatAdminListStreams = (password) => post(CHAT_ADMIN_URL, { action: 'listStreams', password });

export const chatAdminCreateStream = (password, name) => post(CHAT_ADMIN_URL, { action: 'createStream', password, name });

export const chatAdminUpdateStream = (password, streamId, name) => post(CHAT_ADMIN_URL, { action: 'updateStream', password, streamId, name });

export const chatAdminDeleteStream = (password, streamId) => post(CHAT_ADMIN_URL, { action: 'deleteStream', password, streamId });

export const chatAdminAddMember = (password, streamId, login) => post(CHAT_ADMIN_URL, { action: 'addMember', password, streamId, login });

export const chatAdminRemoveMember = (password, streamId, login) => post(CHAT_ADMIN_URL, { action: 'removeMember', password, streamId, login });

export const chatAdminAddMentor = (password, streamId, login) => post(CHAT_ADMIN_URL, { action: 'addMentor', password, streamId, login });

export const chatAdminRemoveMentor = (password, streamId, login) => post(CHAT_ADMIN_URL, { action: 'removeMentor', password, streamId, login });

export const chatAdminListUsers = (password) => post(CHAT_ADMIN_URL, { action: 'listUsers', password });

// --- Отчёт по нарушениям (report-sync, 20:10 МСК) -------------------------
const REPORT_SYNC_URL = 'https://functions.yandexcloud.net/d4ejq776hg6v93bu0e2c';

// Статус: мои потоки + отправлен ли отчёт за сегодня (для кнопки наставника).
export const reportGetStatus = (login, token) => post(REPORT_SYNC_URL, { action: 'getStatus', login, token });

// Отправить отчёт вручную (кнопка наставника). streamId — конкретный поток.
// force=true — отправить повторно, даже если сегодня уже отправляли.
export const reportRunNow = (login, token, streamId, force) =>
  post(REPORT_SYNC_URL, { action: 'runReport', login, token, streamId, force: !!force });

